import { render } from "./TgwBoost.vue?vue&type=template&id=e06f4986&scoped=true"
import script from "./TgwBoost.vue?vue&type=script&lang=ts"
export * from "./TgwBoost.vue?vue&type=script&lang=ts"

import "./TgwBoost.vue?vue&type=style&index=0&id=e06f4986&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e06f4986"

export default script